import React from "react";
import Marquee from "react-fast-marquee";

export default function MarqueeBand({ items = [], speed = 36 }) {
  return (
    <div className="editorial-band" data-testid="marquee-band">
      <Marquee speed={speed} gradient={false} pauseOnHover>
        {items.map((it, i) => (
          <span key={i} className="mx-5 inline-flex items-center gap-5">
            <span>{it}</span>
            <span className="text-[#FF6B9E] text-sm">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
